import React from "react";
import Style from "./index.module.scss";
import { Modal } from "antd";
import TimeTable from "../../../TimeTable";

interface Props {
    name: string;
}
export default function Index({ name, ...restProps }: Props) {
    return (
        <Modal
            title="上课时间表"
            maskClosable={false}
            {...restProps}
            width={1200}
            centered
            className={Style.root}>
            <TimeTable name={name} />
        </Modal>
    );
}
